var _path, _path2, _polygon, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctors2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 25.54,
    width: 55.25,
    height: 105.44,
    rx: 5.21,
    transform: "translate(65.56 -33.57) rotate(38.06)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.79,123.56c-.06.06-5.79-4.33-12.8-9.82s-12.65-10-12.6-10.07,5.78,4.33,12.8,9.82S67.84,123.49,67.79,123.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.88,52.82c-.06.07-5.79-4.33-12.8-9.82S95.42,33,95.48,32.93s5.78,4.33,12.8,9.82S120.93,52.75,120.88,52.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,112.84C54.3,112.78,66.43,97.18,81.45,78s27.26-34.7,27.33-34.65S96.73,59,81.7,78.19,54.44,112.89,54.37,112.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.88,48.13l3.19-4.28,4,3a2.66,2.66,0,0,1,.54,3.73h0a2.67,2.67,0,0,1-3.73.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.79,44.39,88.6,48.66l-4-3A2.68,2.68,0,0,1,84,41.92h0a2.66,2.66,0,0,1,3.73-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54,63.91l3.19-4.28,4,3a2.68,2.68,0,0,1,.55,3.74h0a2.68,2.68,0,0,1-3.74.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.45,60.16l-3.19,4.28-4-3a2.66,2.66,0,0,1-.54-3.73h0a2.66,2.66,0,0,1,3.73-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.93,59.93l3.19-4.28,4,3a2.68,2.68,0,0,1,.55,3.74h0a2.68,2.68,0,0,1-3.74.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.83,56.18l-3.18,4.28-4-3a2.66,2.66,0,0,1-.54-3.73h0a2.66,2.66,0,0,1,3.73-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.06,76.05l3.19-4.27,4,3a2.67,2.67,0,0,1,.55,3.73h0a2.67,2.67,0,0,1-3.74.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,72.31l-3.18,4.28-4-3a2.66,2.66,0,0,1-.54-3.73h0a2.67,2.67,0,0,1,3.73-.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,71.72l3.19-4.28,4,3a2.66,2.66,0,0,1,.54,3.73h0a2.67,2.67,0,0,1-3.73.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.88,68l-3.19,4.28-4-3a2.66,2.66,0,0,1-.55-3.73h0A2.67,2.67,0,0,1,69.84,65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.58,88.2l3.18-4.28,4,3a2.66,2.66,0,0,1,.54,3.73h0a2.67,2.67,0,0,1-3.73.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.48,84.46l-3.19,4.28-4-3A2.67,2.67,0,0,1,87.71,82h0a2.68,2.68,0,0,1,3.74-.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.82,83.84,63,79.56l4,3a2.66,2.66,0,0,1,.54,3.73h0a2.66,2.66,0,0,1-3.73.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.72,80.09l-3.19,4.28-4-3A2.68,2.68,0,0,1,56,77.63h0a2.68,2.68,0,0,1,3.74-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6,100.07l3.19-4.28,4,3a2.66,2.66,0,0,1,.55,3.73h0a2.66,2.66,0,0,1-3.73.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.51,96.33l-3.19,4.27-4-3a2.68,2.68,0,0,1-.54-3.74h0a2.66,2.66,0,0,1,3.73-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.84,97.49,54,93.21l4,3a2.68,2.68,0,0,1,.54,3.74h0a2.66,2.66,0,0,1-3.73.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.75,93.74,51.56,98l-4-3A2.67,2.67,0,0,1,47,91.28h0a2.66,2.66,0,0,1,3.73-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.57,112.93l3.19-4.28,4,3a2.66,2.66,0,0,1,.55,3.73h0a2.66,2.66,0,0,1-3.73.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.48,109.18l-3.19,4.28-4-3a2.68,2.68,0,0,1-.54-3.74h0a2.66,2.66,0,0,1,3.73-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.46,301.46l-64.24,21.89a5.21,5.21,0,0,1-6.61-3.26L353.8,188.55a5.21,5.21,0,0,1,3.25-6.62l64.24-21.88a5.21,5.21,0,0,1,6.61,3.25l44.81,131.55A5.2,5.2,0,0,1,469.46,301.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.42,200.14a5.73,5.73,0,1,1-7.27-3.57A5.73,5.73,0,0,1,386.42,200.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.92,189.41a5.72,5.72,0,1,1-7.26-3.57A5.72,5.72,0,0,1,417.92,189.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.39,229.43a5.72,5.72,0,1,1-7.26-3.57A5.71,5.71,0,0,1,396.39,229.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.9,218.7a5.72,5.72,0,1,1-7.26-3.57A5.72,5.72,0,0,1,427.9,218.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.37,258.73a5.72,5.72,0,1,1-7.26-3.57A5.72,5.72,0,0,1,406.37,258.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.88,248a5.72,5.72,0,1,1-7.26-3.57A5.72,5.72,0,0,1,437.88,248Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.35,288a5.72,5.72,0,1,1-7.26-3.57A5.72,5.72,0,0,1,416.35,288Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.86,277.29a5.72,5.72,0,1,1-7.26-3.57A5.72,5.72,0,0,1,447.86,277.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.35,197.07a32.55,32.55,0,0,1-2.24,4.9,31,31,0,0,1-2.64,4.7,32.55,32.55,0,0,1,2.24-4.9A30.6,30.6,0,0,1,383.35,197.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,186.3a32.38,32.38,0,0,1-2.23,4.91,32.71,32.71,0,0,1-2.64,4.7,32.89,32.89,0,0,1,2.23-4.91A33.41,33.41,0,0,1,414.2,186.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.62,226.36a33.93,33.93,0,0,1-2,5.15,32.73,32.73,0,0,1-2.4,5,34.84,34.84,0,0,1,2-5.15A33.33,33.33,0,0,1,393.62,226.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.74,215.56a30.17,30.17,0,0,1-1.7,5,31.3,31.3,0,0,1-2.13,4.85,30.51,30.51,0,0,1,1.7-5A32.42,32.42,0,0,1,424.74,215.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.66,255.53a56,56,0,0,1-4,9.26,56,56,0,0,1,4-9.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.93,245.29a57.59,57.59,0,0,1-4.78,9.06,28.13,28.13,0,0,1,2.19-4.63A30.15,30.15,0,0,1,434.93,245.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.49,285.24a31.88,31.88,0,0,1-2.37,4.81,31.49,31.49,0,0,1-2.77,4.59,63,63,0,0,1,5.14-9.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.93,273.56a37.53,37.53,0,0,1-2,5.49,36.9,36.9,0,0,1-2.42,5.31,37.4,37.4,0,0,1,2-5.49A36.28,36.28,0,0,1,444.93,273.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.42,293c0,.12-9.61,3.51-21.55,7.58s-21.67,7.27-21.71,7.15,9.61-3.51,21.56-7.58S456.38,292.86,456.42,293Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.6,175.21c0,.11-9.61,3.51-21.56,7.58s-21.66,7.27-21.7,7.15,9.61-3.51,21.56-7.58S413.56,175.09,413.6,175.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.59,188.45a.33.33,0,0,1-.17,0l-.06,0,0,0h0l.44-.14h0c0,.07,0,.17-.16.21s-.24,0-.27-.07h0l.44-.14h0v0s0,.05,0,.06A.27.27,0,0,1,392.59,188.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.32,300.59c-.12,0-9.24-26.42-20.38-59.1S392.88,182.27,393,182.23s9.24,26.42,20.37,59.11S433.44,300.55,433.32,300.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,397.32h51.62a0,0,0,0,1,0,0V498.21a6.28,6.28,0,0,1-6.28,6.28H230.93a6.28,6.28,0,0,1-6.28-6.28V397.32A0,0,0,0,1,224.65,397.32Z",
    transform: "translate(-216.1 670.83) rotate(-86.19)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.61,
    y: 437.22,
    width: 32.44,
    height: 46.38,
    transform: "translate(-227.1 678.07) rotate(-86.19)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.33,
    y: 439.09,
    width: 62.04,
    height: 17.92,
    rx: 2.1,
    transform: "translate(-263.76 614.18) rotate(-86.19)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.56,474.66a73.21,73.21,0,0,1-9-.32,74,74,0,0,1-8.92-.87,73.21,73.21,0,0,1,9,.32A73.72,73.72,0,0,1,203.56,474.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.89,469.66a70.71,70.71,0,0,1-8.95-.32,73.72,73.72,0,0,1-8.92-.87,75.51,75.51,0,0,1,8.95.32A73.72,73.72,0,0,1,203.89,469.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.23,464.67a73.21,73.21,0,0,1-9-.32,73.72,73.72,0,0,1-8.92-.87,73.21,73.21,0,0,1,9,.32A74,74,0,0,1,204.23,464.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,459.67a73.21,73.21,0,0,1-9-.32,73.72,73.72,0,0,1-8.92-.87,75.7,75.7,0,0,1,9,.32A73.72,73.72,0,0,1,204.56,459.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,454.68a73,73,0,0,1-8.95-.32,74,74,0,0,1-8.93-.87,73.21,73.21,0,0,1,9,.32A73.72,73.72,0,0,1,204.89,454.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,449.68a73.18,73.18,0,0,1-9-.32,73.72,73.72,0,0,1-8.92-.87,75.51,75.51,0,0,1,9,.32A74,74,0,0,1,205.23,449.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.56,444.69a73.21,73.21,0,0,1-9-.32,73.72,73.72,0,0,1-8.92-.87,73.21,73.21,0,0,1,9,.32A74,74,0,0,1,205.56,444.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.89,439.69a73.21,73.21,0,0,1-9-.32,74,74,0,0,1-8.92-.87,75.7,75.7,0,0,1,9,.32A73.72,73.72,0,0,1,205.89,439.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.22,434.7a73,73,0,0,1-8.95-.32,73.72,73.72,0,0,1-8.92-.87,73,73,0,0,1,9,.32A73.72,73.72,0,0,1,206.22,434.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,429.7a73.21,73.21,0,0,1-9-.32,73.72,73.72,0,0,1-8.92-.87,75.7,75.7,0,0,1,9,.32A74,74,0,0,1,206.56,429.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,424.71a73.21,73.21,0,0,1-9-.32,73.72,73.72,0,0,1-8.92-.87,73.21,73.21,0,0,1,9,.32A73.72,73.72,0,0,1,206.89,424.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.22,419.71a73,73,0,0,1-8.95-.32,74,74,0,0,1-8.93-.87,73.21,73.21,0,0,1,9,.32A73.72,73.72,0,0,1,207.22,419.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.29,456.65h2.91a3,3,0,0,1,3,3v9.9a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0v-9.9A3,3,0,0,1,290.29,456.65Z",
    transform: "translate(552.05 944.61) rotate(-176.19)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,445.26H294a3,3,0,0,1,3,3v9.9a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0v-9.9a3,3,0,0,1,3-3Z",
    transform: "matrix(1, 0.07, -0.07, 1, 30.68, -18.45)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.72,430.82h2.91a3,3,0,0,1,3,3v9.9a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0v-9.9A3,3,0,0,1,265.72,430.82Z",
    transform: "matrix(-0.26, 0.97, -0.97, -0.26, 758.67, 292.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,427.87h2.91a3,3,0,0,1,3,3v9.9a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0v-9.9A3,3,0,0,1,254.68,427.87Z",
    transform: "translate(-229.65 569.45) rotate(-75.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,430h2.91a3,3,0,0,1,3,3v9.9a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0V433A3,3,0,0,1,290.21,430Z",
    transform: "matrix(0.27, 0.96, -0.96, 0.27, 634.23, 38.7)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.2,433.06h2.91a3,3,0,0,1,3,3V446a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0v-9.9A3,3,0,0,1,279.2,433.06Z",
    transform: "matrix(-0.27, -0.96, 0.96, -0.27, -67.8, 827.51)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.34,456.19h2.91a3,3,0,0,1,3,3v9.9a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0v-9.9a3,3,0,0,1,3-3Z",
    transform: "translate(360.29 995.95) rotate(-157.81)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.66,445.61h2.91a3,3,0,0,1,3,3v9.9a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0v-9.9A3,3,0,0,1,280.66,445.61Z",
    transform: "translate(191.63 -73.07) rotate(22.19)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.24,76,423,84.6a.78.78,0,0,1-.13,1.08l-8.69,6.75a6.23,6.23,0,0,1-8.75-1.09h0a6.24,6.24,0,0,1,1.09-8.76l8.69-6.75A.78.78,0,0,1,416.24,76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.3,85.88l-6.72-8.63a.77.77,0,0,1,.14-1.08l8.68-6.75a6.23,6.23,0,0,1,8.75,1.09h0a6.24,6.24,0,0,1-1.09,8.76L422.38,86A.77.77,0,0,1,421.3,85.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.32,280.76l10.29,3.74a.78.78,0,0,1,.46,1l-3.76,10.33a6.24,6.24,0,0,1-8,3.74h0a6.25,6.25,0,0,1-3.74-8l3.76-10.33A.77.77,0,0,1,31.32,280.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.89,286.47l-10.28-3.74a.76.76,0,0,1-.46-1l3.76-10.34a6.23,6.23,0,0,1,8-3.73h0a6.23,6.23,0,0,1,3.73,8L41.88,286A.78.78,0,0,1,40.89,286.47Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463,478.94c0,.15-95.84.26-214,.26s-214-.11-214-.26,95.82-.26,214.05-.26S463,478.8,463,478.94Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.22,
    y: 37.17,
    width: 261.17,
    height: 344.95,
    rx: 10.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.7,
    y: 53.47,
    width: 226.19,
    height: 304.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.9,358.42c0-2.08-.1-124.39-.24-305l.24.23-226.17,0h0l.26-.26c0,113.73,0,219.11,0,305l-.22-.22,226.2.22-226.2.21h-.21v-.21c0-85.84,0-191.22-.05-305v-.26h.29l226.17,0h.23v.24C374,234,373.9,356.34,373.9,358.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.32,104.65l-5.27-7.93h-5.83v7.93h-6.33V76.19h11.84a14.73,14.73,0,0,1,6.32,1.26A9.45,9.45,0,0,1,200.17,81a10.08,10.08,0,0,1,1.45,5.49A9.9,9.9,0,0,1,200.15,92,9.31,9.31,0,0,1,196,95.5l6.14,9.15Zm-1.6-21.81a6.44,6.44,0,0,0-4.34-1.28h-5.16v9.92h5.16a6.4,6.4,0,0,0,4.34-1.31,5.25,5.25,0,0,0,0-7.33Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.17,124.32,202.91,115l-6.15,9.36h-6.89l9.6-13.71-9.12-13.25h6.82l6,8.74L209,97.36h6.48l-9,13,9.67,13.94Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.53,
    y: 82.99,
    width: 38.82,
    height: 9.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.28,89.06c0,.15-10.62.26-23.72.26s-23.71-.11-23.71-.26,10.61-.26,23.71-.26S352.28,88.92,352.28,89.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.39,100.59c0,.14-21.24.26-47.43.26s-47.43-.12-47.43-.26,21.23-.27,47.43-.27S351.39,100.44,351.39,100.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.39,111.88c0,.14-21.24.26-47.43.26s-47.43-.12-47.43-.26,21.23-.26,47.43-.26S351.39,111.73,351.39,111.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.19,142c0,.14-47.19.26-105.38.26s-105.39-.12-105.39-.26,47.17-.27,105.39-.27S366.19,141.83,366.19,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.19,312.46c0,.14-47.19.26-105.38.26s-105.39-.12-105.39-.26,47.17-.26,105.39-.26S366.19,312.31,366.19,312.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.78,
    y: 159.23,
    width: 65.03,
    height: 12.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.78,
    y: 329.86,
    width: 28.15,
    height: 12.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.3,
    y: 329.86,
    width: 28.15,
    height: 12.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.11,338.31c0,.15-8.79.26-19.63.26s-19.64-.11-19.64-.26,8.79-.26,19.64-.26S248.11,338.17,248.11,338.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.19,338.31c0,.15-8.79.26-19.63.26s-19.64-.11-19.64-.26,8.79-.26,19.64-.26S349.19,338.17,349.19,338.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.86,189.8c0,.14-38.53.26-86,.26s-86-.12-86-.26,38.51-.26,86-.26S346.86,189.65,346.86,189.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.2,203.72c0,.15-39.27.26-87.7.26s-87.71-.11-87.71-.26,39.26-.26,87.71-.26S350.2,203.58,350.2,203.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,217.65c0,.14-19.49.26-43.52.26s-43.52-.12-43.52-.26,19.48-.26,43.52-.26S259.82,217.5,259.82,217.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.91,268.15s-.19.08-.58.2l-1.7.52a57.22,57.22,0,0,1-6.69,1.56,31.29,31.29,0,0,1-4.94.47,20.69,20.69,0,0,1-5.87-.73,15,15,0,0,1-5.93-3.29,11.37,11.37,0,0,1-3.57-6.67,7.85,7.85,0,0,1,.49-4.1,7.69,7.69,0,0,1,2.78-3.32,5.8,5.8,0,0,1,4.39-.93,5.91,5.91,0,0,1,2.12,1,6.46,6.46,0,0,1,1.52,1.85,10.06,10.06,0,0,1,1.07,4.72,13.48,13.48,0,0,1-.9,4.9,19.45,19.45,0,0,1-6.23,8.18,20.85,20.85,0,0,1-10,4.2,18.34,18.34,0,0,1-5.63-.07,18.89,18.89,0,0,1-2.79-.67,22.44,22.44,0,0,1-2.66-1.18,16.25,16.25,0,0,1-4.51-3.72,12.44,12.44,0,0,1-2.67-5.33,8.69,8.69,0,0,1,.71-6,9.09,9.09,0,0,1,4.41-4.22,6.29,6.29,0,0,1,3.09-.54,6,6,0,0,1,2.91,1.1,8.86,8.86,0,0,1,3.17,5.14,16.77,16.77,0,0,1,.32,5.94,23.86,23.86,0,0,1-1.29,5.69,21.61,21.61,0,0,1-6.28,9.37,17.13,17.13,0,0,1-10,4.09,14.41,14.41,0,0,1-15.38-10.61,13.69,13.69,0,0,1,.34-9,7.75,7.75,0,0,1,2.62-3.44,4.59,4.59,0,0,1,2-.83,3.2,3.2,0,0,1,2.06.39,4.43,4.43,0,0,1,2,3.38,10.79,10.79,0,0,1-.15,3.73,27.34,27.34,0,0,1-2,6.48,26.48,26.48,0,0,1-3,5.07,25.41,25.41,0,0,1-3.34,3.68,24.25,24.25,0,0,1-5.62,3.92,15.88,15.88,0,0,1-1.62.75l-.57.22.55-.27c.36-.18.92-.4,1.6-.79a25.45,25.45,0,0,0,5.53-4,27.81,27.81,0,0,0,6.24-8.72,26.71,26.71,0,0,0,2-6.41,11,11,0,0,0,.13-3.63,4.13,4.13,0,0,0-1.82-3.11,2.83,2.83,0,0,0-1.83-.34,4.21,4.21,0,0,0-1.79.78,7.32,7.32,0,0,0-2.48,3.27,13.25,13.25,0,0,0-.29,8.74,14,14,0,0,0,14.92,10.26,16.69,16.69,0,0,0,9.69-4,21.05,21.05,0,0,0,6.12-9.16,23.8,23.8,0,0,0,1.26-5.58,16.21,16.21,0,0,0-.32-5.76,8.25,8.25,0,0,0-3-4.83,5.44,5.44,0,0,0-5.49-.51,8.6,8.6,0,0,0-4.16,4,8.14,8.14,0,0,0-.66,5.63,13.77,13.77,0,0,0,6.92,8.72,22.59,22.59,0,0,0,2.57,1.14,18.34,18.34,0,0,0,8.19.73,20.67,20.67,0,0,0,5.19-1.43,21,21,0,0,0,4.55-2.66,19,19,0,0,0,6.09-8,13.14,13.14,0,0,0,.89-4.73,9.69,9.69,0,0,0-1-4.51,6.38,6.38,0,0,0-1.4-1.73,5.47,5.47,0,0,0-1.95-1,5.39,5.39,0,0,0-4.08.86,7.2,7.2,0,0,0-2.64,3.13,7.52,7.52,0,0,0-.49,3.91,11.08,11.08,0,0,0,3.44,6.47,14.75,14.75,0,0,0,5.79,3.25,20.39,20.39,0,0,0,5.78.76,31.33,31.33,0,0,0,4.91-.42,65.16,65.16,0,0,0,6.69-1.46l1.72-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.06,
    y: 34.24,
    width: 75.48,
    height: 28.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.54,63.09s0-.18,0-.52,0-.85,0-1.5c0-1.33,0-3.25,0-5.73,0-5-.06-12.17-.1-21.1l.18.18-75.47.08h0l.26-.26c0,10.08,0,19.83,0,28.85l-.25-.25,54,.12,15.73.07,4.23,0,1.1,0h.38a2.06,2.06,0,0,1-.35,0h-1.07l-4.17,0-15.68.07-54.21.11h-.25v-.25c0-9,0-18.77,0-28.85l.26-.26h0l75.47.08h.18v.18c0,9-.07,16.2-.1,21.21,0,2.46,0,4.37,0,5.69,0,.63,0,1.12,0,1.47S298.54,63.09,298.54,63.09Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Medication--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.94,478.5H340.06a4,4,0,0,1-4-3.93l-1.18-131.83h56.82l1.18,131.75A4,4,0,0,1,388.94,478.5Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.75,372V473.49s8,2.66,8.39-4.34.18-97.17.18-97.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.34,336.05h-46a3,3,0,0,0-3,3V342h52V339A3,3,0,0,0,386.34,336.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.34,336.05a1.72,1.72,0,0,1,.5,0,2.85,2.85,0,0,1,1.36.55,3.05,3.05,0,0,1,1.21,2.06c0,1,0,2,0,3.28v.12h-.13c-9.53.07-27.94.13-49,.13h-3.25v-3.05a3.29,3.29,0,0,1,1.17-2.62,3.25,3.25,0,0,1,1.31-.66,6.21,6.21,0,0,1,1.4-.09h2.66l10.11,0,17,.06,11.43.08,3.1,0,.8,0,.27,0-.27,0-.8,0-3.1,0-11.43.08-17,.06-10.11,0h-2.66a5.28,5.28,0,0,0-1.28.08,2.85,2.85,0,0,0-1.1.55c-1.44,1.09-.86,3.19-1,5l-.26-.26h3c21.09,0,39.5.05,49,.13l-.13.13c0-1.23,0-2.34,0-3.25a2.92,2.92,0,0,0-1.09-2A3.4,3.4,0,0,0,386.34,336.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.92,
    y: 340.57,
    width: 68.79,
    height: 31.41,
    rx: 2.64,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,372s.18,0,.5-.08a2.56,2.56,0,0,0,1.27-.68c1.17-.88.7-3,.77-5.43,0-5-.05-12.15-.08-21,0-.55,0-1.11,0-1.68a2.42,2.42,0,0,0-.55-1.46,2.55,2.55,0,0,0-1.37-.84,11,11,0,0,0-1.74-.05h-7.54l-16.64,0-38.11,0a2.37,2.37,0,0,0-1.95,1,2.3,2.3,0,0,0-.41,1,12,12,0,0,0,0,1.22v14.7c0,3.18,0,6.31,0,9.38v1.15a2.43,2.43,0,0,0,.22,1,2.39,2.39,0,0,0,1.5,1.3,3,3,0,0,0,1.05.1h3.32l31.13.05,21,.09,5.7,0,1.49,0,.5,0-.5,0-1.49,0-5.7.05-21,.08-31.13.06h-3.32a3.46,3.46,0,0,1-1.18-.12,2.89,2.89,0,0,1-1.82-1.56,3,3,0,0,1-.26-1.21v-1.15q0-4.6,0-9.38c0-3.19,0-6.44,0-9.73v-5c0-.43,0-.82,0-1.29a3,3,0,0,1,.51-1.28,2.89,2.89,0,0,1,2.37-1.22l38.11,0,16.64,0,7.54,0a10.33,10.33,0,0,1,1.83.07,3,3,0,0,1,1.58,1,2.89,2.89,0,0,1,.63,1.7v1.69c0,8.84-.07,16-.09,21,0,1.23,0,2.33,0,3.29a2.74,2.74,0,0,1-.88,2.22,2.52,2.52,0,0,1-1.33.65A1.65,1.65,0,0,1,395.07,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,371.46c-.15,0-.26-6.69-.26-14.93s.11-14.94.26-14.94.26,6.69.26,14.94S333.06,371.46,332.92,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.12,371.46c-.15,0-.26-6.69-.26-14.93s.11-14.94.26-14.94.26,6.69.26,14.94S338.26,371.46,338.12,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.32,371.46c-.14,0-.26-6.69-.26-14.93s.12-14.94.26-14.94.26,6.69.26,14.94S343.46,371.46,343.32,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.52,371.46c-.14,0-.26-6.69-.26-14.93s.12-14.94.26-14.94.26,6.69.26,14.94S348.67,371.46,348.52,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.73,371.46c-.15,0-.26-6.69-.26-14.93s.11-14.94.26-14.94.26,6.69.26,14.94S353.87,371.46,353.73,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.93,371.46c-.15,0-.26-6.69-.26-14.93s.11-14.94.26-14.94.26,6.69.26,14.94S359.07,371.46,358.93,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.13,371.46c-.14,0-.26-6.69-.26-14.93s.12-14.94.26-14.94.26,6.69.26,14.94S364.27,371.46,364.13,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.33,371.46c-.14,0-.26-6.69-.26-14.93s.12-14.94.26-14.94.26,6.69.26,14.94S369.48,371.46,369.33,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53,371.46c-.14,0-.26-6.69-.26-14.93s.12-14.94.26-14.94.27,6.69.27,14.94S374.68,371.46,374.53,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.74,371.46c-.15,0-.26-6.69-.26-14.93s.11-14.94.26-14.94.26,6.69.26,14.94S379.88,371.46,379.74,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.94,371.46c-.14,0-.26-6.69-.26-14.93s.12-14.94.26-14.94.26,6.69.26,14.94S385.08,371.46,384.94,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,371.46c-.14,0-.26-6.69-.26-14.93s.12-14.94.26-14.94.26,6.69.26,14.94S390.29,371.46,390.14,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.34,371.46c-.14,0-.26-6.69-.26-14.93s.12-14.94.26-14.94.26,6.69.26,14.94S395.49,371.46,395.34,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.36,
    y: 395.64,
    width: 49.19,
    height: 39.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.81,408.18l-1.15-1.66H345.4v1.66H344v-5.94h2.57a3.17,3.17,0,0,1,1.36.27,2,2,0,0,1,.9.74,2.06,2.06,0,0,1,.31,1.15,2,2,0,0,1-.32,1.14,2,2,0,0,1-.9.73l1.33,1.91Zm-.35-4.55a1.44,1.44,0,0,0-.94-.27H345.4v2.07h1.12a1.44,1.44,0,0,0,.94-.27,1.07,1.07,0,0,0,0-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.81,412.28l-1.36-1.95-1.33,1.95h-1.49l2.08-2.86-2-2.76h1.48l1.29,1.82,1.27-1.82h1.41l-2,2.71,2.09,2.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.85,
    y: 402.23,
    width: 28.09,
    height: 4.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.75,417.1c0,.14-8.2.26-18.32.26s-18.32-.12-18.32-.26,8.2-.26,18.32-.26S381.75,417,381.75,417.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.75,421.54c0,.15-8.2.26-18.32.26s-18.32-.11-18.32-.26,8.2-.26,18.32-.26S381.75,421.4,381.75,421.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.46,
    y: 427.11,
    width: 18.98,
    height: 3.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.43,433.81s0-.24,0-.7,0-1.14,0-2c0-1.77,0-4.32-.05-7.57,0-6.52-.07-15.8-.11-27l.21.22-47.15,0c-.06.05.49-.49.26-.25h0v9.92c0,3.26,0,6.46,0,9.58,0,6.25,0,12.21,0,17.76l-.23-.23,34,.12,9.66.06,2.58,0h.9s-.06,0-.21,0h-.64l-2.53,0-9.61.06-34.16.12h-.23v-.24c0-5.55,0-11.51,0-17.76,0-3.12,0-6.32,0-9.58v-9.92h0c-.23.22.32-.33.26-.27l47.15,0h.22v.22c0,11.25-.09,20.59-.11,27.14,0,3.22-.05,5.76-.06,7.52,0,.84,0,1.49,0,2S387.43,433.81,387.43,433.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.12,467.75c-.15,0-.26-20.56-.26-45.92s.11-45.92.26-45.92.26,20.56.26,45.92S338.26,467.75,338.12,467.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6,476.36c0,.14-10.73.26-24,.26s-24-.12-24-.26,10.73-.26,24-.26S388.6,476.22,388.6,476.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.35,478.44h-39.6a3.22,3.22,0,0,1-3.22-3.19l-1-106.79h46l.95,106.73A3.21,3.21,0,0,1,437.35,478.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.52,392.14v82.24s6.48,2.15,6.8-3.52.14-78.72.14-78.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.67,363H398.5a3,3,0,0,0-3,3v1.79h42.14V366A3,3,0,0,0,434.67,363Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.67,363a1.57,1.57,0,0,1,.43,0,2.69,2.69,0,0,1,1.2.4,3.09,3.09,0,0,1,1.3,1.59,3.75,3.75,0,0,1,.18,1.31c0,.47,0,1,0,1.48V368h-.13c-7.79.08-22.42.13-39.15.13h-3.26v-.26c0-.76,0-1.45,0-2.25a3.25,3.25,0,0,1,3.29-2.78h2.12l8.05,0,13.54.05,9.07.08,2.46.05a5.58,5.58,0,0,1,.85.05,5.58,5.58,0,0,1-.85,0l-2.46.05-9.07.08-13.54.06H398.58a2.75,2.75,0,0,0-1.82.63,2.66,2.66,0,0,0-.95,1.71c-.06.66,0,1.45,0,2.18l-.26-.26h3c16.73,0,31.36.05,39.15.13l-.13.13c0-.52,0-1,0-1.48a3.29,3.29,0,0,0-.14-1.24,2.91,2.91,0,0,0-1.17-1.54A3.59,3.59,0,0,0,434.67,363Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.73,
    y: 366.7,
    width: 55.73,
    height: 25.45,
    rx: 2.64,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.81,392.14a3,3,0,0,0,1.48-.52,2.63,2.63,0,0,0,1-1.54,5.31,5.31,0,0,0,.05-1.22c0-.44,0-.92,0-1.41,0-4-.05-9.79-.08-16.91,0-.44,0-.91,0-1.35a2.4,2.4,0,0,0-.41-1.2,2.48,2.48,0,0,0-2.29-1.09h-6.08l-13.4,0-30.71,0a2.39,2.39,0,0,0-2.38,2.3c0,1.34,0,2.67,0,4v7.84q0,3.86,0,7.56a4.57,4.57,0,0,0,.17,1.73,2.5,2.5,0,0,0,1.07,1.22,3,3,0,0,0,1.63.3h1.78l25.08.06,16.91.08,4.6,0,1.19,0,.41,0-.41,0-1.19,0-4.6.05-16.91.08-25.08.06h-1.78A3.47,3.47,0,0,1,390,392a3,3,0,0,1-1.29-1.47,3,3,0,0,1-.2-1v-.93q0-3.7,0-7.56V369.24a2.91,2.91,0,0,1,2.9-2.8l30.71,0,13.4,0h6.08a3,3,0,0,1,2.62,1.29,2.79,2.79,0,0,1,.45,1.39c0,.48,0,.92,0,1.37,0,7.12-.07,12.89-.09,16.91,0,.49,0,1,0,1.41a5.64,5.64,0,0,1-.08,1.25,2.67,2.67,0,0,1-1.11,1.6,2.51,2.51,0,0,1-1.13.42A1.28,1.28,0,0,1,441.81,392.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,391.72c-.14,0-.26-5.41-.26-12.09s.12-12.1.26-12.1.26,5.41.26,12.1S392.1,391.72,392,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.17,391.72c-.14,0-.26-5.41-.26-12.09s.12-12.1.26-12.1.26,5.41.26,12.1S396.32,391.72,396.17,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.39,391.72c-.15,0-.26-5.41-.26-12.09s.11-12.1.26-12.1.26,5.41.26,12.1S400.53,391.72,400.39,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6,391.72c-.14,0-.26-5.41-.26-12.09s.12-12.1.26-12.1.26,5.41.26,12.1S404.75,391.72,404.6,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.82,391.72c-.15,0-.26-5.41-.26-12.09s.11-12.1.26-12.1.26,5.41.26,12.1S409,391.72,408.82,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,391.72c-.14,0-.26-5.41-.26-12.09s.12-12.1.26-12.1.26,5.41.26,12.1S413.18,391.72,413,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.25,391.72c-.15,0-.26-5.41-.26-12.09s.11-12.1.26-12.1.26,5.41.26,12.1S417.39,391.72,417.25,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.46,391.72c-.14,0-.26-5.41-.26-12.09s.12-12.1.26-12.1.26,5.41.26,12.1S421.6,391.72,421.46,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.68,391.72c-.15,0-.27-5.41-.27-12.09s.12-12.1.27-12.1.26,5.41.26,12.1S425.82,391.72,425.68,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.89,391.72c-.14,0-.26-5.41-.26-12.09s.12-12.1.26-12.1.26,5.41.26,12.1S430,391.72,429.89,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.1,391.72c-.14,0-.26-5.41-.26-12.09s.12-12.1.26-12.1.26,5.41.26,12.1S434.25,391.72,434.1,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.32,391.72c-.15,0-.26-5.41-.26-12.09s.11-12.1.26-12.1.26,5.41.26,12.1S438.46,391.72,438.32,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.53,391.72c-.14,0-.26-5.41-.26-12.09s.12-12.1.26-12.1.26,5.41.26,12.1S442.68,391.72,442.53,391.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.18,
    y: 411.31,
    width: 39.85,
    height: 31.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,421.47l-.92-1.34h-1v1.34H401v-4.81H403a2.68,2.68,0,0,1,1.11.21,1.61,1.61,0,0,1,.72.61,1.78,1.78,0,0,1,0,1.85,1.6,1.6,0,0,1-.73.59l1.08,1.55Zm-.28-3.69a1.19,1.19,0,0,0-.76-.21h-.91v1.67H403a1.13,1.13,0,0,0,.76-.22.74.74,0,0,0,.26-.62A.75.75,0,0,0,403.74,417.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,424.79l-1.1-1.58-1.08,1.58h-1.21l1.68-2.32-1.6-2.23h1.2l1,1.47,1-1.47h1.14L406,422.43l1.69,2.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.35,
    y: 416.65,
    width: 22.75,
    height: 3.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.52,428.69c0,.15-6.64.26-14.84.26s-14.84-.11-14.84-.26,6.64-.26,14.84-.26S431.52,428.55,431.52,428.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.52,432.3c0,.14-6.64.26-14.84.26s-14.84-.12-14.84-.26,6.64-.26,14.84-.26S431.52,432.15,431.52,432.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.69,
    y: 436.8,
    width: 15.38,
    height: 2.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.12,442.24s0-.21,0-.58,0-.94,0-1.62c0-1.45,0-3.52-.05-6.14,0-5.29-.07-12.8-.11-21.86l.21.22-38.19,0,.26-.26h0v4c0,1.35,0,2.68,0,4v7.76c0,5.06,0,9.88,0,14.39l-.23-.24,27.53.12,7.84.06,2.09,0h.54l.19,0h-.68l-2,0-7.79.06-27.68.12h-.24v-.23c0-4.51,0-9.33,0-14.39v-15.8h0c-.23.23.32-.32.27-.26l38.19,0h.22V412c0,9.11-.09,16.68-.11,22,0,2.6-.05,4.65-.06,6.08,0,.67,0,1.2,0,1.59A3.6,3.6,0,0,1,436.12,442.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.17,469.73c-.14,0-.26-16.66-.26-37.2s.12-37.2.26-37.2.26,16.65.26,37.2S396.32,469.73,396.17,469.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.07,476.7c0,.15-8.7.26-19.42.26s-19.41-.11-19.41-.26,8.69-.26,19.41-.26S437.07,476.56,437.07,476.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.31,435.73l-6.63,23.55S131.81,474.1,131,478.57L86,467l8.87-37.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.24,453.71a1.92,1.92,0,0,0-1.79,1.83,1.85,1.85,0,0,0,1.75,1.84,2,2,0,0,0,1.89-1.94c-.09-.95-1.12-1.94-2-1.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,467l1-3.7,42.78,12.45s1.79,1.4,1.21,2.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.47,459.23c-.07.23-1.19,0-2.45.49s-2.07,1.25-2.25,1.11.47-1.36,2-1.87S111.56,459,111.47,459.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7,462.44c0,.24-1,.37-2,1.14s-1.44,1.71-1.66,1.64,0-1.37,1.19-2.29S115.75,462.23,115.7,462.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,468.92c-.21,0-.24-1.2.62-2.29s2-1.32,2.06-1.11-.75.71-1.45,1.62S117.19,469,117,468.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.4,453.7c-.15.18-1.08-.39-2.34-.62s-2.33-.08-2.4-.31,1.06-.78,2.54-.49S112.55,453.55,112.4,453.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53,441.28l-1,24.48s24,9.31,24.18,13.86l-46.41-.37.1-38.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.15,463.59a1.94,1.94,0,0,0-1.33,2.2,1.81,1.81,0,0,0,2.12,1.37,2.05,2.05,0,0,0,1.4-2.34A1.87,1.87,0,0,0,86,463.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.25,479.25l.16-3.85,44.44,1.79s2.06.94,1.81,2.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,465.53c0,.23-1.14.33-2.27,1.06s-1.72,1.71-1.93,1.62.14-1.43,1.52-2.3S101.29,465.31,101.24,465.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.09,467.63c0,.22-.93.61-1.71,1.59s-1,2-1.23,2-.36-1.33.63-2.52S106.09,467.41,106.09,467.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.81,473.62c-.21.05-.51-1.11.08-2.38s1.65-1.77,1.75-1.57-.57.87-1,1.91S109,473.6,108.81,473.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87,459.92c-.09.21-1.13-.12-2.41,0s-2.29.49-2.4.29.85-1,2.36-1.1S101,459.74,100.87,459.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.82,262.11v19.36l5.07,75.42s-3.16,36.59-5.1,57.25c-1.68,17.93,1.07,49.17,1.07,49.17H103.4L114,359.14l6.56-65L132,264.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.61 265.48 144.95 370.71 115.07 449.5 113.69 454.24 96.05 449.87 109.17 263.43 150.61 265.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.46,294.94a3,3,0,0,1,0,.44c0,.32,0,.74,0,1.28,0,1.16-.08,2.82-.15,4.94-.12,4.28-.42,10.47-.84,18.12-.89,15.3-2.55,36.41-5.15,59.65s-5.37,44.22-7.43,59.4c-1,7.56-1.89,13.69-2.48,18-.3,2.1-.54,3.74-.7,4.88-.09.54-.15,1-.2,1.27a2.39,2.39,0,0,1-.09.43l0-.44c0-.31.09-.73.15-1.27.14-1.15.34-2.79.6-4.9.54-4.27,1.33-10.41,2.31-18,2-15.19,4.71-36.17,7.27-59.41s4.31-44.31,5.3-59.6c.47-7.64.83-13.83,1-18.11.11-2.12.19-3.77.25-4.93,0-.54.06-1,.08-1.28A2.19,2.19,0,0,1,120.46,294.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,268.62a1.52,1.52,0,1,1-1.52-1.56A1.53,1.53,0,0,1,122.33,268.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,283.32a10,10,0,0,1-2.08-2,24.11,24.11,0,0,1-3.72-6,24.55,24.55,0,0,1-1.86-6.81,9.91,9.91,0,0,1-.07-2.92c.09,0,.15,1.11.45,2.87a29.44,29.44,0,0,0,2,6.63,29,29,0,0,0,3.51,5.93C147.59,282.46,148.36,283.25,148.3,283.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.77,167.18s5.65,2.22,8.27,10.5c1.82,5.76,10.34,48.64,10.34,48.64l-11.88,7.83L146.67,194Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.59,146.7l-3.72,6.6S71,165.94,71.09,167.18c0,0,1.39,47.18,1.65,81.79.1,13.07-.38,25.08-.64,30.85-.69,15.15-1.23,74-1.23,74l90-2.13L144.77,167.18l-12.7-5.55-1.62-3.31-5.83-4.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,352.18a2,2,0,0,0,0-.4c0-.29,0-.68-.05-1.17-.06-1.07-.14-2.59-.25-4.53-.23-3.95-.57-9.63-1-16.62-.85-14.06-2-33.44-3.31-54.85s-2.35-40.79-3.16-54.86c-.37-7-.68-12.67-.89-16.63-.11-1.94-.19-3.45-.25-4.52,0-.49-.06-.88-.08-1.17a3,3,0,0,0-.05-.4,2.38,2.38,0,0,0,0,.4c0,.29,0,.68,0,1.18,0,1.06.08,2.58.15,4.52.14,3.93.39,9.62.72,16.64.66,14,1.72,33.45,3,54.88s2.52,40.8,3.47,54.83c.48,7,.88,12.66,1.15,16.62.15,1.93.27,3.45.35,4.51l.1,1.18A1.8,1.8,0,0,0,139,352.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "124.62 153.58 126.71 168.03 130.45 197.03 114.15 169.05 100 150.51 123.32 166.85 123.61 153.31",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.76,154.18a6.37,6.37,0,0,0,.45,1.13c.35.79.81,1.84,1.39,3.13l5.06,11,.06.14h.16l3.4,0-.16-.46-2.5,2.05-.23.19.21.21,4.74,4.64L123.59,191l4.66,4.43,1.29,1.19a2.61,2.61,0,0,0,.47.39,2.15,2.15,0,0,0-.4-.47l-1.21-1.26-4.55-4.56-15.13-14.9c-1.63-1.6-3.23-3.15-4.75-4.63v.39l2.49-2.06.55-.46h-.72l-3.4,0,.22.14c-2.13-4.44-3.93-8.2-5.24-10.92-.63-1.27-1.13-2.3-1.51-3.07A7.61,7.61,0,0,0,95.76,154.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.45,197a12.07,12.07,0,0,0,.33-1.8c.18-1.25.41-2.91.69-4.92.56-4.16,1.3-9.91,2.08-16.26l.72-5.92,0-.23-.23-.06-4.09-1v.48l4.1-.73.28-.05-.12-.25-2.7-5.87c-.31-.63-.56-1.16-.77-1.59a2,2,0,0,0-.31-.54,2.5,2.5,0,0,0,.2.59c.18.44.4,1,.66,1.64.64,1.5,1.5,3.51,2.53,5.94l.16-.29-4.11.67-1.18.19,1.16.29,4.08,1-.2-.28c-.24,1.88-.48,3.87-.74,5.91-.78,6.36-1.46,12.11-1.92,16.28-.21,2-.39,3.69-.52,5A11.61,11.61,0,0,0,130.45,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.54,274.21l-.58,0-1.73.11-6.64.48-23.78,1.83-.24,0,0,.24c.38,4.47.8,9.33,1.24,14.45q.33,3.86.68,7.89c.12,1.35.23,2.7.35,4.07a11,11,0,0,0,.33,2.1,7.37,7.37,0,0,0,.94,2,8.57,8.57,0,0,0,5.59,3.37,45.55,45.55,0,0,0,6.34.34,53.69,53.69,0,0,0,11.89-1.3,17.9,17.9,0,0,0,2.71-.89,8.3,8.3,0,0,0,1.26-.64,4.1,4.1,0,0,0,.57-.46,5.81,5.81,0,0,0,.45-.56,13.27,13.27,0,0,0,1.55-5.07,62.35,62.35,0,0,0,.47-9.41c-.09-5.76-.5-10.4-.81-13.6-.15-1.6-.3-2.83-.41-3.67,0-.4-.1-.71-.13-1a1,1,0,0,0-.07-.32s0,.11,0,.33,0,.56.08,1c.08.88.18,2.11.31,3.68.25,3.2.6,7.84.64,13.58a65.73,65.73,0,0,1-.53,9.34,13,13,0,0,1-1.51,4.87,4.07,4.07,0,0,1-2.08,1.48,17.2,17.2,0,0,1-2.63.85,53.69,53.69,0,0,1-11.77,1.26,45.09,45.09,0,0,1-6.24-.34,8.06,8.06,0,0,1-5.25-3.15,7.26,7.26,0,0,1-.86-1.8,10.86,10.86,0,0,1-.31-2c-.12-1.37-.24-2.73-.35-4.08-.24-2.68-.47-5.32-.7-7.88-.46-5.13-.89-10-1.29-14.45l-.21.26,23.61-2.06,6.68-.61,1.78-.17A4.68,4.68,0,0,0,116.54,274.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.22,304.74c2.54,6.62,9.17,7,16.31,6,6.71-1,13.17-2.39,13.67-4.31-.18,3.51-2.76,6.2-6,7.61a23.32,23.32,0,0,1-10.33,1.45c-3.67-.17-6.84,0-9.87-2.09S86.21,307.76,86.22,304.74Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M154.29,276.26a1.18,1.18,0,0,1,0-.25l-.09-.72q-.1-1-.3-2.79c-.24-2.48-.58-6-1-10.28-.82-8.68-1.92-20.68-3.08-33.93s-2.16-25.26-2.83-34c-.33-4.35-.57-7.87-.71-10.3-.08-1.22-.11-2.16-.13-2.81,0-.29,0-.53,0-.73a.72.72,0,0,1,0-.25c.24,2.82,1.91,21.93,4.19,48,1.14,13.24,2.18,25.22,2.93,33.95.35,4.31.64,7.81.84,10.29.09,1.18.16,2.12.21,2.8,0,.29,0,.53,0,.73A1,1,0,0,1,154.29,276.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,227.27a12.5,12.5,0,0,1,.42,4.26c-.21,2.19-.31,7.57-6.14,9.41s-8.66.08-10.45-2.39l-.89-10.7,6.24-4.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.62,234.15S103.71,248.88,92.13,251s-15.72-2-18.8-12.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M71.36,166.82s-9.47,8.78-6.77,29.57c2.5,19.32,7,46.22,12.88,49.35s18.73,1.56,28.1-3.75,36.52-19.67,36.52-19.67l-11.24-20-36.21,14s-4.68-32-7.49-37.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,178.39s.1.21.28.62c.08.2.2.45.32.76s.22.69.36,1.1c.53,1.66,1.16,4.15,1.85,7.39,1.4,6.47,3.09,15.91,4.87,27.67l-.26-.16,36.19-14.1.2-.08.11.19c3.55,6.32,7.33,13,11.25,20l.13.24-.24.13-23.22,12.51-11.39,6.13c-1.87,1-3.73,2.05-5.66,2.88a47.17,47.17,0,0,1-5.92,2.05,38.71,38.71,0,0,1-12.08,1.4A17.69,17.69,0,0,1,78,245.87l-.68-.3c-.22-.11-.43-.27-.65-.41a6.58,6.58,0,0,1-1-1.06,13.85,13.85,0,0,1-1.53-2.47,55.53,55.53,0,0,1-3.64-10.48c-.91-3.47-1.63-6.88-2.28-10.19-1.28-6.61-2.23-12.81-3-18.48s-1.5-10.83-1.29-15.4a38.37,38.37,0,0,1,2.06-11.47,25.44,25.44,0,0,1,3.43-6.52,15.19,15.19,0,0,1,1.24-1.47,5.85,5.85,0,0,1,.48-.44l-.44.48a17.29,17.29,0,0,0-1.19,1.49,26.13,26.13,0,0,0-3.32,6.53,38.34,38.34,0,0,0-2,11.41c-.18,4.54.54,9.67,1.36,15.33s1.79,11.86,3.09,18.46c.65,3.29,1.38,6.69,2.3,10.15a55.39,55.39,0,0,0,3.61,10.38A14.06,14.06,0,0,0,76,243.78a6.42,6.42,0,0,0,1,1,4.69,4.69,0,0,0,.58.35l.64.29a17.2,17.2,0,0,0,5.64,1.17,38.33,38.33,0,0,0,11.91-1.39,48.08,48.08,0,0,0,5.84-2c1.92-.83,3.74-1.86,5.62-2.86l11.39-6.14,23.23-12.5-.11.36-11.22-20,.31.11-36.23,14-.23.09,0-.24c-1.73-11.75-3.36-21.2-4.69-27.68-.65-3.24-1.25-5.74-1.75-7.4-.12-.41-.23-.78-.33-1.1l-.29-.77C87.11,178.61,87,178.39,87,178.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 196.38,
    width: 17.97,
    height: 5.98,
    transform: "translate(217.97 398.73) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.72,199a29.21,29.21,0,0,1,5.6-.27,29.28,29.28,0,0,1,5.61.27,30.86,30.86,0,0,1-5.61.26A30.79,30.79,0,0,1,103.72,199Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "129.54 196.64 103.09 175.18 103.72 173.31 101.42 173.31 97.6 158.44 103.1 169.24 106.28 169.09 103.97 171.21 129.54 196.64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.87,172.18l1-.4c0-.05-2.17-5.22-4.3-10.7a10.58,10.58,0,0,1-.9-5.38,2.51,2.51,0,0,1,2.54-2l.7-.37.36-.64c-1.85-.4-4.33,1.15-4.63,2.86a11.61,11.61,0,0,0,1,5.94C94.69,167,96.84,172.13,96.87,172.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31,184.26l1.33-.52c-1.09-2.81-2.58-7.78-1.94-9.18a4.17,4.17,0,0,1,2.86-1.89,4.78,4.78,0,0,1,4.17.86c1.52,1.29,3.82,5.83,4.58,7.48l1.29-.6c-.11-.25-2.87-6.22-4.95-8a6.18,6.18,0,0,0-5.4-1.16A5.43,5.43,0,0,0,93.41,174C92.33,176.32,94.8,183,95.31,184.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.67,205.94c1.64,0,3.26-.88,4.81-2.62l-.54-.48c-1.7,1.93-3.46,2.69-5.2,2.28-7.11-1.67-12.53-21.42-12.58-21.62l-.69.18c.23.83,5.58,20.37,13.1,22.13A4.59,4.59,0,0,0,109.67,205.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.11,204.13h0a.85.85,0,0,0,1.11.08l1.54-1.15a1,1,0,0,0,.29-1.42h0a1,1,0,0,0-1.57-.15l-1.39,1.44A.85.85,0,0,0,113.11,204.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.65,206.59a5.57,5.57,0,0,0,4.85-2.17c4.37-6.13-3.87-23.15-4.22-23.87l-.64.31c.08.18,8.41,17.36,4.28,23.15-1.08,1.51-3,2.11-5.62,1.78l-.09.7A10.47,10.47,0,0,0,106.65,206.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,206.2h0a.85.85,0,0,1-.78.79l-1.92.16a1,1,0,0,1-1.15-.87h0a1,1,0,0,1,1.07-1.16l2,.17A.86.86,0,0,1,106.78,206.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 180.24,
    r: 5.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 180.24,
    r: 5.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.25,180.24a3.76,3.76,0,1,0,3.75-3.75A3.75,3.75,0,0,0,137.25,180.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.22,158.11c.48.69,5.79,11.9,8.69,17.55l.85-.44c-.43-.83-8.15-16.76-8.75-17.65L125.39,153l-.2,1.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.09,180.12c3.68,3.67,13,13.22,13,13.22l2.49-1.5-13.12-14a1.64,1.64,0,0,0-2.11-.24h0A1.64,1.64,0,0,0,128.09,180.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74,201.91l3.13-8.82a5,5,0,0,1,4.51-3.38l.47,0c1.88.21,11.45.84,11.45.84l3.7,4.15a1.89,1.89,0,0,1,0,2.5h0l1.07,7.5L153,206.14l.21,5.24s-1.87,1.24-2.7.83l-.84-.42-1.24-1.25-3.54,5L140,218.37Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.06,197.62a17,17,0,0,0-1.34-1.45,6.31,6.31,0,0,0-1.79-1.08,13.41,13.41,0,0,0-2.59-.35,43.74,43.74,0,0,1-6.83-.92,43.69,43.69,0,0,1,6.88.38,11.37,11.37,0,0,1,2.71.42,6,6,0,0,1,1.88,1.26A3.18,3.18,0,0,1,154.06,197.62Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.85,204.51a15.5,15.5,0,0,0-.77-1.91,7.43,7.43,0,0,0-3.7-3.1,14.06,14.06,0,0,0-4.9-.83,10.89,10.89,0,0,1-2.1-.06,6.25,6.25,0,0,1,2.1-.32,12.14,12.14,0,0,1,5.1.7,7.2,7.2,0,0,1,3.84,3.43A3.24,3.24,0,0,1,153.85,204.51Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.91,210.94a4.06,4.06,0,0,1-.5-2.06,6.9,6.9,0,0,0-.47-2.15,2.64,2.64,0,0,0-2-1.49,37.2,37.2,0,0,0-5-.72,5.69,5.69,0,0,1-2.07-.48,14.88,14.88,0,0,1,2.11.1,24.8,24.8,0,0,1,5.09.57,4.07,4.07,0,0,1,1.4.65,2.82,2.82,0,0,1,.88,1.17,6.36,6.36,0,0,1,.39,2.32C152.79,210.15,153,210.91,152.91,210.94Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.13 194.4 116.85 237.03 118.44 238.64 148.01 235.31 187.8 197.4 187.76 195.58 158.13 194.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.86,214.28a9.43,9.43,0,0,0-7.25-2.42,13.29,13.29,0,0,0-7.14,3,9.62,9.62,0,0,0-3.56,5.1c-.84,3.58,2.11,8.59,5.36,10.33h0c4.12-3.31,8.13-8.39,12.25-11.69a3.55,3.55,0,0,0,1.43-1.83A2.91,2.91,0,0,0,165.86,214.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M187.64,197.32a3.85,3.85,0,0,1-.54,0h-1.58l-5.92-.07L159,196.89l.19-.08-10.34,10.73-21.45,22.07-6.54,6.64-1.8,1.79a6.67,6.67,0,0,1-.65.6A4.68,4.68,0,0,1,119,238l1.73-1.86,6.42-6.76c5.49-5.71,13-13.54,21.33-22.18,3.65-3.78,7.16-7.4,10.36-10.7l.08-.08H159l20.57.59,5.91.21,1.58.08A2.64,2.64,0,0,1,187.64,197.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.8,209.82s4,.08,5.31.73S172,215,172,215s0,2.6-1,2.7a9.09,9.09,0,0,1,.21,1.77c.1,1.46.31,2.29-1.67,3.54,0,0,.21,2.39-.52,3a14.22,14.22,0,0,1-1.56,1.14s-.11,2.63-3.64,2.6l-3.31,1.46s-7.36-.69-6.58-1.56,2.55-5.18,2.55-5.18-5-3.67-4.94-4.81.52-1.25.52-1.25-.2-2.18,1.56-2.39c0,0,1.36-2.71,2.71-2.81s10.51,3.22,10.51,3.22l-3.43-2.91s-3.44-.52-3.33-1.67S161.8,209.82,161.8,209.82Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.2,223.53a50,50,0,0,1-4.65-2.25A50.55,50.55,0,0,1,151.9,219a16.34,16.34,0,0,1,4.89,1.75A16.7,16.7,0,0,1,161.2,223.53Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,220.35a37,37,0,0,1-6-1.94,36.08,36.08,0,0,1-5.78-2.45,37,37,0,0,1,6,1.94A36.08,36.08,0,0,1,166,220.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,128.2A83.51,83.51,0,0,1,98,114.33a28.74,28.74,0,0,1,1.84-13.91c.29-.66,2.65-5,3.35-4.94.51.07-1,4.2-.78,4.66,2.24,4.34,2.64,9.45,2,14.3a63.86,63.86,0,0,1-3.55,13.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,110.17c.22-11.86,7.31-21.6,19.15-21l1.09.12a21.18,21.18,0,0,1,19,21.59c-.25,10.27-.66,21.61-1.3,27.07-1.33,11.29-12.83,11.86-12.83,11.86s-2.62,17.42-2.62,17.42L99.59,150.41Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.36,149.85a27.52,27.52,0,0,1-14.27-5.91s2.26,9.67,13.65,9.84Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,120.29a1.62,1.62,0,0,1-1.73,1.46,1.55,1.55,0,0,1-1.51-1.63,1.63,1.63,0,0,1,1.73-1.47A1.56,1.56,0,0,1,136.18,120.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.58,115.27c-.22.18-1.35-.85-3.09-1s-3.1.56-3.27.33.16-.47.76-.81a4.41,4.41,0,0,1,2.65-.52,4.3,4.3,0,0,1,2.43,1.07C137.55,114.78,137.69,115.18,137.58,115.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31,119.59a1.63,1.63,0,0,1-1.73,1.47,1.56,1.56,0,0,1-1.51-1.64A1.63,1.63,0,0,1,119.8,118,1.55,1.55,0,0,1,121.31,119.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,114.17c-.22.19-1.35-.84-3.09-1s-3.1.56-3.27.32.16-.46.76-.8a4.41,4.41,0,0,1,2.65-.52,4.3,4.3,0,0,1,2.43,1.07C120.45,113.69,120.59,114.09,120.48,114.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.31,128.19a11.06,11.06,0,0,1,2.88-.21c.44,0,.87,0,1-.34a2.28,2.28,0,0,0-.16-1.35l-.95-3.52c-1.32-5-2.22-9.1-2-9.15s1.43,4,2.75,9c.31,1.23.61,2.41.9,3.53a2.6,2.6,0,0,1,0,1.77,1.11,1.11,0,0,1-.79.57,3,3,0,0,1-.77,0A11.73,11.73,0,0,1,125.31,128.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07,128.85c.28,0,.09,1.9,1.56,3.41s3.5,1.51,3.49,1.78-.49.32-1.34.25a4.69,4.69,0,0,1-2.92-1.38,4.08,4.08,0,0,1-1.19-2.84C119.68,129.27,119.94,128.83,120.07,128.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.13,107.11c-.22.45-1.93,0-4,.08s-3.77.41-4,0c-.1-.22.24-.63,1-1a6.64,6.64,0,0,1,3-.72,6.71,6.71,0,0,1,3,.69C120.89,106.48,121.23,106.89,121.13,107.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.47,109.41c-.35.36-1.5-.17-2.94-.34s-2.68,0-2.92-.46c-.1-.21.13-.59.7-.91a4.12,4.12,0,0,1,2.46-.39,4,4,0,0,1,2.27,1C137.5,108.81,137.63,109.23,137.47,109.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.33,118.64c-.19-.11-7.53-3.12-8.1,4.64s7.34,6.73,7.37,6.51S101.33,118.64,101.33,118.64Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,126.67s-.14.09-.38.18a1.39,1.39,0,0,1-1-.06c-.79-.36-1.39-1.71-1.33-3.11a4.62,4.62,0,0,1,.52-1.91,1.56,1.56,0,0,1,1.1-1,.68.68,0,0,1,.77.43c.09.22,0,.37.07.39s.17-.12.13-.44a.86.86,0,0,0-.27-.51,1,1,0,0,0-.73-.25,1.87,1.87,0,0,0-1.5,1.1,4.66,4.66,0,0,0-.63,2.12c-.06,1.57.63,3.09,1.73,3.5a1.44,1.44,0,0,0,1.25-.12C98.42,126.86,98.47,126.69,98.44,126.67Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,97.64c1.3-.61-2.21-4.92-5.21-6.52-4.53-2.42-11.57-4.18-16-3.24-5.28,1.14-9.75,3.44-12.65,8a30.6,30.6,0,0,0-4.43,15.37,9.29,9.29,0,0,0,.79,4.82c1,1.78,3,3,2.74,5.36a3.26,3.26,0,0,0,.65,2.42c1.33,1.61,3.15.3,4.05-1.07,1.9-2.94,2.32-6.55,2.7-10a22.74,22.74,0,0,0,0-7.41c-.3-1.32-.83-2.58-1-3.92a4.67,4.67,0,0,1,.8-3.84,4.84,4.84,0,0,1,.67-.59,8.11,8.11,0,0,1,8.13-1c4.27,1.83,11.59,4.62,13.64,3.26,2.94-1.95,3.7-3.3,3.7-3.3Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors2);
export default __webpack_public_path__ + "static/media/Doctors2.3091132cdddc8a063e95e2e013afccd1.svg";
export { ForwardRef as ReactComponent };